function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2016(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.47,
    height: 9.03,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.12875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 4.515
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.03,
    width: 22.47,
    height: 24.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.80875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 21.384999999999998
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.74,
    width: 22.47,
    height: 28.34,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.494
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 47.910000000000004
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 62.08,
    width: 22.47,
    height: 31.8,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.494
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 77.98
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 93.88,
    width: 22.47,
    height: 39.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7449999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 113.55499999999999
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 133.23,
    width: 22.47,
    height: 39.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4966666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 152.98
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 172.73,
    width: 22.47,
    height: 46.35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 195.905
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 219.08,
    width: 22.47,
    height: 47.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.80875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 242.74
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 266.4,
    width: 22.47,
    height: 48.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.494
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 290.45
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 314.51,
    width: 22.47,
    height: 49.81,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 339.41499999999996
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 364.32,
    width: 22.47,
    height: 52.4,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.80875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 390.52
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 416.72,
    width: 22.47,
    height: 53.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.247
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 443.605
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 470.48,
    width: 22.47,
    height: 55.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.80875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 498.42
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 526.36,
    width: 22.47,
    height: 56.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.80875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 554.78
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 583.2,
    width: 22.47,
    height: 56.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.80875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 611.6450000000001
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 640.09,
    width: 22.47,
    height: 59.91,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7449999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.235,
    y: 670.0450000000001
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.47,
    y: 0,
    width: 31.37,
    height: 43.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.2283333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.155,
    y: 21.945
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.83,
    y: 0,
    width: 32.18,
    height: 43.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.436
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.92,
    y: 21.945
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.01,
    y: 0,
    width: 34.75,
    height: 43.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.385,
    y: 21.945
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.77,
    y: 0,
    width: 36.99,
    height: 43.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.165
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.265,
    y: 21.945
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.76,
    y: 0,
    width: 38.22,
    height: 43.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.87,
    y: 21.945
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.98,
    y: 0,
    width: 38.22,
    height: 43.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.08999999999997,
    y: 21.945
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.19,
    y: 0,
    width: 43.25,
    height: 43.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.178571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.815,
    y: 21.945
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.45,
    y: 0,
    width: 43.27,
    height: 43.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.327
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.085,
    y: 21.945
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.72,
    y: 0,
    width: 43.32,
    height: 43.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.38000000000005,
    y: 21.945
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.04,
    y: 0,
    width: 44.63,
    height: 43.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.48625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 386.355,
    y: 21.945
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.67,
    y: 0,
    width: 45.06,
    height: 43.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 431.20000000000005,
    y: 21.945
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.72,
    y: 0,
    width: 45.18,
    height: 43.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 476.31,
    y: 21.945
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.9,
    y: 0,
    width: 45.85,
    height: 43.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2700000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 521.8249999999999,
    y: 21.945
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.76,
    y: 0,
    width: 47.83,
    height: 43.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.675,
    y: 21.945
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.59,
    y: 0,
    width: 52.19,
    height: 43.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2700000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.6850000000001,
    y: 21.945
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 644.78,
    y: 0,
    width: 55.22,
    height: 43.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.876666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.39,
    y: 21.945
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.47,
    y: 43.89,
    width: 57.02,
    height: 43.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6183333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.980000000000004,
    y: 65.6
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.47,
    y: 87.31,
    width: 57.02,
    height: 44.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.980000000000004,
    y: 109.36
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.47,
    y: 131.41,
    width: 57.02,
    height: 46.73,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.675714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.980000000000004,
    y: 154.775
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.47,
    y: 178.14,
    width: 57.02,
    height: 47.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.88875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.980000000000004,
    y: 201.695
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.47,
    y: 225.25,
    width: 57.02,
    height: 53.53,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.921666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.980000000000004,
    y: 252.015
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.47,
    y: 278.78,
    width: 57.02,
    height: 54.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.001666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.980000000000004,
    y: 305.78499999999997
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.47,
    y: 332.79,
    width: 57.02,
    height: 58.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.145714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.980000000000004,
    y: 361.92
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.47,
    y: 391.05,
    width: 57.02,
    height: 60.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.702
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.980000000000004,
    y: 421.16
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.47,
    y: 451.26,
    width: 57.02,
    height: 74.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.183636363636364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.980000000000004,
    y: 488.57
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.47,
    y: 525.89,
    width: 57.02,
    height: 79.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.702
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.980000000000004,
    y: 565.6
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.47,
    y: 605.31,
    width: 57.02,
    height: 94.69,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.503333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.980000000000004,
    y: 652.655
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.49,
    y: 43.89,
    width: 67.58,
    height: 80.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.263333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.28,
    y: 84.16499999999999
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.07,
    y: 43.89,
    width: 71.66,
    height: 80.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.943333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.89999999999998,
    y: 84.16499999999999
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.73,
    y: 43.89,
    width: 72.81,
    height: 80.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.401428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.135,
    y: 84.16499999999999
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.53,
    y: 43.89,
    width: 89.21,
    height: 80.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.06875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.135,
    y: 84.16499999999999
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.75,
    y: 43.89,
    width: 103.1,
    height: 80.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.06875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.3,
    y: 84.16499999999999
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.85,
    y: 43.89,
    width: 106.34,
    height: 80.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.06875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.02,
    y: 84.16499999999999
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 590.19,
    y: 43.89,
    width: 109.81,
    height: 80.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.424999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 645.095,
    y: 84.16499999999999
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.49,
    y: 124.44,
    width: 142.2,
    height: 67.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.58999999999997,
    y: 158.385
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.49,
    y: 192.33,
    width: 142.2,
    height: 80.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.58999999999997,
    y: 232.78000000000003
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.49,
    y: 273.23,
    width: 142.2,
    height: 93.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.58999999999997,
    y: 319.91
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.49,
    y: 366.6,
    width: 142.2,
    height: 154.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.58999999999997,
    y: 443.84000000000003
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.49,
    y: 521.08,
    width: 142.2,
    height: 178.92,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 28.439999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.58999999999997,
    y: 610.5400000000001
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.69,
    y: 124.44,
    width: 134.48,
    height: 198.17,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.225454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.93,
    y: 223.52499999999998
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.17,
    y: 124.44,
    width: 136.56,
    height: 198.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 34.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 424.45000000000005,
    y: 223.52499999999998
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 492.74,
    y: 124.44,
    width: 207.26,
    height: 198.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 33.02833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.37,
    y: 223.52499999999998
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.69,
    y: 322.61,
    width: 227.01,
    height: 186.82,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.3525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.195,
    y: 416.02
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.69,
    y: 509.43,
    width: 227.01,
    height: 190.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.224285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.195,
    y: 604.715
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.69,
    y: 322.61,
    width: 251.31,
    height: 173.75,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 28.958333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.345,
    y: 409.485
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.69,
    y: 496.36,
    width: 251.31,
    height: 203.64,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 40.727999999999994
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.345,
    y: 598.1800000000001
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2016);
export default __webpack_public_path__ + "static/media/2016.c43cf20fd1fb6a4372e862f2455ba3fb.svg";
export { ForwardRef as ReactComponent };